export function normalizeSlugNodeId(id) {
    return String(id || "")
        .trim()
        .replace(/[^a-zA-Z0-9_-]/g, "_");
}

export function getSlugNodeClassName(id, slot = "root") {
    const normalizedId = normalizeSlugNodeId(id);
    if (!normalizedId) return "";

    return slot === "root"
        ? `slug-node-${normalizedId}`
        : `slug-node-${normalizedId}--${slot}`;
}
